@if (isSpouse === false) {
  <h2 id="information-sur-lentrepreneur">Informations sur l'entrepreneur</h2>
}
@if (isSpouse === true) {
  <h2 id="information-sur-le-conjoint">Informations sur le conjoint</h2>
}

<div class="d-flex gap-3">
  <magieno-input-text-field
          class="flex-fill"
          [advancedFormControl]="this.incomeTaxPersonalSpouseForm.formElements.lastName | asAdvancedFormControl"></magieno-input-text-field>

  <magieno-input-text-field
          class="flex-fill"
          [advancedFormControl]="this.incomeTaxPersonalSpouseForm.formElements.firstName | asAdvancedFormControl"></magieno-input-text-field>
</div>

<div class="d-flex mt-3">

  <magieno-datepicker
          [advancedFormControl]="this.incomeTaxPersonalSpouseForm.formElements.birthdate | asAdvancedFormControl">
    <i class="fas fa-calendar" calendarIcon></i>
  </magieno-datepicker>
</div>


@if (isSpouse === false) {
  <div class="d-flex mb-4">
    <magieno-boolean-select
            [advancedFormControl]="incomeTaxPersonalForm.formElements.isMarried | asAdvancedFormControl"></magieno-boolean-select>
  </div>
}

@if (isSpouse === false) {
  <h2 id="revenus-de-entrepreneur">Revenus de l'entrepreneur</h2>
}
@if (isSpouse === true) {
  <h2 id="revenus-du-conjoint" style="margin-top:90px;">Revenus du conjoint</h2>
}

<div class="d-flex mt-3">
  <magieno-input-money-field
          [advancedFormControl]="this.incomeTaxPersonalSpouseForm.formElements.employmentIncome | asAdvancedFormControl"
          [currency]="this.currency"
          [locale]="this.locale"></magieno-input-money-field>
</div>

<div class="d-flex mt-3">
  <magieno-boolean-select
          [advancedFormControl]="this.incomeTaxPersonalSpouseForm.formElements.isEmployeeSubjectToEI | asAdvancedFormControl"></magieno-boolean-select>

</div>

<div class="d-flex gap-4 mt-3">
  <magieno-input-money-field
          class="flex-fill"
          [advancedFormControl]="this.incomeTaxPersonalSpouseForm.formElements.realEligibleDividend | asAdvancedFormControl"
          [currency]="this.currency"
          [locale]="this.locale"></magieno-input-money-field>

  <magieno-input-money-field
          class="flex-fill"
          [advancedFormControl]="this.incomeTaxPersonalSpouseForm.formElements.realNonEligibleDividend | asAdvancedFormControl"
          [currency]="this.currency"
          [locale]="this.locale"></magieno-input-money-field>
</div>

<div class="d-flex gap-4 mt-3 mb-4">

  <magieno-input-money-field
          class="flex-fill"
          [advancedFormControl]="this.incomeTaxPersonalSpouseForm.formElements.gainPubliclyTradeShares | asAdvancedFormControl"
          [currency]="this.currency"
          [locale]="this.locale"></magieno-input-money-field>

  <magieno-input-money-field
          class="flex-fill"
          [advancedFormControl]="this.incomeTaxPersonalSpouseForm.formElements.othersIncomesLine13000 | asAdvancedFormControl"
          [currency]="this.currency"
          [locale]="this.locale"></magieno-input-money-field>
</div>

@if (isSpouse === false) {
  <h2 id="credits-deductions-entrepreneur">Crédits et déductions de l'entrepreneur</h2>
}
@if (isSpouse === true) {
  <h2 id="credits-deductions-conjoint">Crédits et déductions du conjoint</h2>
}

<div class="d-flex gap-4 mt-3">
  <magieno-input-money-field
          [advancedFormControl]="federalForm.formElements.paidContributionRRSP | asAdvancedFormControl"
          [currency]="this.currency"
          [locale]="this.locale"></magieno-input-money-field>

</div>

@if (federalForm.value.paidContributionRRSP > 0) {
  <div class="d-flex gap-4 ms-5 mt-3">
    <magieno-input-money-field
            [advancedFormControl]="federalForm.formElements.maximumAllowedDeductibleContributionsRRSP | asAdvancedFormControl"
            [currency]="this.currency"
            [locale]="this.locale"></magieno-input-money-field>

  </div>
}

<div class="d-flex gap-4 mt-3">
  <magieno-boolean-select
          [advancedFormControl]="this.incomeTaxPersonalSpouseForm.formElements.isEligibleToCWB | asAdvancedFormControl"></magieno-boolean-select>
</div>

